module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("S")])]), _vm._v("eneca walked alongside her soon-to-be agent and into an apartment boasting black-and-white vinyl floors and floor-to-ceiling and wall-to-wall panoramic windows. Booth’s guests were dressed to the nines in ubiquitous New York City black. Ribald laughter and hushed conversations ended when dozens of eyes were directed at her and their host. She stiffened slightly, then relaxed when Booth’s arm went around her waist.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ladies and gentlemen, I’d like to introduce my very special guest and the world’s next supermodel. Seneca Houston.” A spattering of applause followed his announcement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca flashed the demure smile that was to become her signature expression as her eyes met and held a pair that literally and figuratively ate her up. Her smile grew wider as she caught the wink of the NBA’s highest-scoring point guard.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("She didn’t move as the tall, lanky ballplayer wove his way through the small crowd that had gathered in Booth’s enormous condominium, her gaze watching the fluid motion of ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("his approach. He was even more breathtakingly beautiful in person. Olive-skinned, with chiseled cheekbones and defined features he’d inherited from his African-American father and Korean-American mother, Phillip Kingston had become the sports world’s latest heartthrob.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know who you are,” Seneca said when he offered her his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Phillip smiled, exhibiting a wide mouth filled with straight white teeth. “Then we must even the odds, because I know nothing about you. May I get you something to drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She exhaled in an audible breath. It was refreshing to have to tilt her head to look up at a man who towered over her when she wore heels. “No, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He went completely still. “You don’t drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A beat passed. “I don’t drink because I’m not old enough to drink,” Seneca explained.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There came another pause before Phillip asked, “How old are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Twenty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about a soft drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca smiled. “I’ll have sparkling water.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wanted to tell the ballplayer that soda drinks were loaded with sugar and that she’d made it a practice not to drink them. Even the low-calorie drinks were not a part of her diet. She didn’t starve herself like some models, but monitored any and everything that she ate or drank.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Phillip leaned closer, inhaling the subtle fragrance clinging to the exposed flesh of the woman who stirred emotions he didn’t want to feel. Since being signed to the NBA he’d found himself somewhat indifferent to women who literally threw themselves and their underwear at him. It was the ones like Seneca Houston, who were caught up with their own sense of self-importance, that intrigued him. And if Booth ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("had announced her as the next supermodel, then that meant the crafty agent had signed on to represent her.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hadn’t wanted to attend the agent’s party because he’d wanted to return to Los Angeles to reconnect with his family after his team had lost their bid for the play-offs by one point. But Booth had insisted he come. To refuse the Barracuda was like jumping out of a plane without a parachute.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Phillip thought of the agent as a legitimate mobster. A single telephone call from Booth would find a former client either blacklisted or the victim of an assault that made one pray for a quick death. Whenever Booth called, he came. Now he was glad he had come to the boring gathering.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t run away, Miss Almost Legal. I’ll be back with your water.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca stared up through her lashes at the most delicious man she’d ever seen. His skin was nearly poreless, and she wondered whether he had to shave every day. There was enough of a slant in his large eyes to verify his Asian heritage. However, it was his chiseled jaw and strong square chin that held her enthralled. Her gaze moved up his coarse, close-cropped straight black hair before moving slowly over a pair of broad shoulders under a chocolate-brown silk jacket, matching shirt and linen slacks. Phillip Kingston was more than eye candy. He was comparable to the confections found in Jacques Torres Chocolate Haven. In other words, he was a visual feast.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I won’t be going anywhere for a while,” Seneca said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hadn’t realized she’d been holding her breath until Phillip walked over to the portable bar to get her drink. Luis had wished her luck, and apparently it was with her. Booth Gordon had promised to represent her, and Phillip Kingston appeared to be as attracted to her as she was to him. No doubt it was going to be a remarkable evening.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca glanced around the expansive living room. Dimmed recessed lights, dozens of flickering tapers in silver holders, votives in tiny glass vases on every flat surface and baskets of white flowers in every variety added a festive touch to the all-white décor. Partially opened pocket doors revealed a table in the formal dining room. The many bulbs in a massive crystal chandelier sparkled like stars over the table set with silver, china and crystal stemware.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I see you’ve caught the eye of my latest prize.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A shiver swept over Seneca when she felt Booth’s moist breath in her ear. She peered over her shoulder at the agent. “Who are you talking about?” she asked, feigning ignorance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She knew he was referring to Phillip Kingston, but there was something in his tone that reminded her of someone who’d just purchased a spectacular thoroughbred. And she wondered if he regarded all of his clients as prizes, or just those who earned six, seven and occasionally eight figures, from which he’d netted incalculable sums in commissions for his ability to ink unheard-of deals.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Kingston,” Booth said in a velvet whisper. “FYI, he’s very particular about the women he usually consorts with.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca turned, glaring at the man who’d promised to make her a supermodel. But, she mused, at what cost? “I am not consorting with Phillip Kingston. He just offered to bring me a drink.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As your host, I should’ve offered to do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A hint of a smile played at the corners of her mouth. “But it looks as if your prize beat you to it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("Booth clamped down on his teeth to keep from spewing expletives. He’d vowed to curtail his colorful language after one of his employees sued him. He’d called a gofer “a dumb-ass, dick-sucking faggot,” and a month later he was charged ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("with sexual discrimination. The agency’s lawyer agreed to settle out of court, and the little weasel accepted a six-figure check on the spot, then signed documents with a gag order that he would never mention the incident again or he would be subject to a countersuit for defamation. One thing Booth detested was giving away money, and if the snitch hadn’t been the son of one of his uncle’s friends he would’ve personally blown his brains out.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An innate instinct told him that Seneca Houston wasn’t going to be an easy client. But instinct also told him the exotic beauty was going to make a great deal of money in commissions for him. He would put up with her sharp tongue until she got a taste of fame and fortune. Then the ball would liter ally be in his court, where he’d have the upper hand in all her bookings.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fortunately, he had been blessed with acute instincts. Within minutes of meeting someone, he knew whether to give them the time of day or totally ignore them. Booth hadn’t become the lawyer his social-climbing mother had wanted him to be. However, he was blessed with something money and higher education couldn’t buy—a heightened sense of survival. He was also a visionary. The clients who signed with his agency weren’t just actors, models, performers or athletes. BG Management Agency had turned them into megastars.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Phillip returned with a glass filled with a clear sparkling liquid and a sliver of lime, and Booth’s gaze darted from the ballplayer to Seneca, his mind awash with ideas. Both were tall and exotic-looking. Tom Brady had married supermodel Gisele Bündchen, and as the agent for Phillip Kingston and Seneca Houston he would market them as a celebrity couple. Waiting until Seneca took a sip of her beverage, he reached for her free hand. “I had the waitstaff rearrange the place ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("cards at the table. You and Seneca will be seated together,” he informed Phillip.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s Mitchell?” Seneca asked, her eyes darting around the living room as she looked for the photographer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Booth gave her fingers a gentle squeeze. “He called earlier to say he was running late. He should be here before the second course is served.” The words were barely off his tongue when Mitchell Leon strolled into the living room. Tall, thin and with salt-and-pepper hair fashioned into shoulder-length twists, he had dark skin reminiscent of sculpted mahogany African masks. He’d hoped the talented photographer would’ve opted to wear a shirt and jacket instead of the misshapen cotton sweaters he favored regardless of the season. Booth sighed inaudibly. At least he’d exchanged his ubiquitous jeans for a pair of slacks. With his approach he noticed the pants were slightly wrinkled. Was it, he mused, too much for the man to take his clothes to a dry cleaner?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reluctantly, he released Seneca’s hand and extended his to Mitchell. “Mitch, my boy, I’m glad you could make it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frowning, Mitchell Leon ignored the proffered hand and leaned over to plant a kiss on Seneca’s cheek. “Hey, beautiful.” He gave Phillip a nod. “I’m sorry you guys didn’t make the play-offs,” he said to Phillip. “I need a drink,” he said, switching the topic of the conversation without taking a breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Three pairs of eyes followed the emaciated-looking man with strangely colored gold eyes as he headed for the bar. “Now, that’s one strange dude,” Booth muttered under his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca smiled. “His genius outweighs his eccentricity.” She owed her modeling career to Luis and Mitchell. One dressed her and the other photographed her and had made it possible for her to meet Booth Gordon. “Excuse me, gentlemen, but I need to speak to Mitchell.”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Talking long, fluid strides, she sidled up to her friend as he asked the bartender for vodka on the rocks. “He announced to everyone that I was going to be a supermodel,” she said in a hushed whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Smiling, Mitchell gave her a sidelong glance. “And knowing Gordon he will make it happen. The Barracuda could never resist a beautiful woman. Especially one that hasn’t been surgically altered.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why do you call him that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s because he is one,” Mitchell said. “Booth Gordon is aggressive and at times a tad bit unethical. He will do whatever he has to do to get what he wants for his clients.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca took a sip of her drink, staring over the rim at the model-turned-photographer. Mitchell was only thirty-three but was graying prematurely, the gray totally incongruent with his youthful-looking dark face. His features were more European than African, and with his light-colored eyes he’d garnered a lot of attention from both men and women.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mitchell had lived with a model, but their relationship had imploded when he returned home to find her in bed with their next-door neighbor. Seneca, fearing that Mitchell, after he’d had an emotional meltdown, would harm either himself or the unfaithful woman, invited him to stay with her until he found another apartment. She’d offered him her bedroom while she’d slept on the convertible sofa in the living room. Six weeks later he moved into a Tribeca loft.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Does that include you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mitchell took a deep swallow of his cocktail, grimacing when it slid down the back of his throat before a warming spread throughout his chest. “Booth spearheaded my modeling career, but when I told him I wanted to photograph models he made it happen for me. However, when it stops being good, then I’ll look for another agent.”")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca wanted to tell him that she hoped that wouldn’t happen for a very long time. She and Mitchell had connected, he with her and she with his camera lens, the instant she’d stepped onto the set for a Macy’s Christmas catalog. When she was told that she would do the shoot with M. Leon, she’d believed it would be with the international male model. However, much to her shock, he wasn’t a model but the photographer. There was something in the luminous golden orbs that was mesmerizing and electrifying, and for the first time since she’d begun modeling she came alive under the lights.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca met Mitchell’s eyes. “Do you miss modeling?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mitchell’s lips parted in a sensual smile. “No. Rather than posing with beautiful women I get the bonus of peering at them from behind a camera lens.” Without warning, he sobered. “You’re going to become a sensation, Seneca,” he predicted sagely. “Working with Booth isn’t going to be easy, because the man has an ego as big as Mount Rushmore. But on the other hand, he will make you a supermodel. Just make certain you don’t sign away your soul.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mitchell’s warning stayed with Seneca as she sat with Booth on her left and Phillip on her right with ten other couples. Booth sat at the head of the table opposite his latest barely legal girlfriend, presiding over the assembly like a Roman emperor at a banquet. With a mere wave of his hand or a nod he silently ordered the waitstaff when to bring or clear away each course.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("She ate slowly, sparingly, as she sipped her drink. No one seemed to notice that she’d left more food on the plate than she’d consumed. Unlike many women who had a career in modeling, Seneca had never resorted to bingeing, then regurgitating her food. Rice, pasta, potatoes and bread topped her restricted-foods list. She’d made allowances for protein ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("intake: chicken, fish, beans, peas and no more than four ounces of red meat each week. Booth’s personal chef had prepared a rack of lamb with an herb crust, but Seneca found it too undercooked.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is there something wrong with the lamb?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca nodded. Booth had read her mind. “It’s a little rare for my tastes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raising his hand, he beckoned a waiter. “Please bring Ms. Houston a well-done portion of lamb. Take her plate, fool,” he rasped, noticeably annoyed with the man’s incompetence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She opened her mouth to chide Booth for his rudeness but just as quickly changed her mind. Her objection was not to what he said but how he’d said it. His tone was a constant reminder of how her mother had ordered her children about as if they were her slaves. It would never be “please,” or “would you,” but “do this or that, and be quick about it.” And if she’d dawdled too long, then Seneca would find an object sailing within inches of her head. She didn’t know how she did it, but Dahlia Houston’s aim was near-perfect. She never hit any of her children, although she’d come very close too many times to count.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why don’t you take my plate,” Phillip suggested, picking up his plate and setting it down in front of Seneca, “and I’ll take yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you sure?” she asked him, her voice barely above a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Phillip beckoned the waiter. “I’ll take that.” Picking up the knife at his place setting, he cut into the fork-tender meat and popped it into his mouth. “It’s good.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Seneca found herself watching him chew until he swallowed. He had the sexiest mouth of any man she’d ever seen. She’d never been one to gawk or go weak-kneed over a good-looking man; however, she was willing to make an exception ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("with Phillip Kingston. He was tall, at least six-six, his body beautifully proportioned. Even his hands were perfect.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She picked up her knife. “I don’t eat much red meat, and when I do I like it well-done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Phillip leaned to his left, his shoulder brushing against Seneca’s bare one. “Do you eat?” he teased. “You hardly touched your soup and salad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You noticed?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled, attractive slashes creasing his lean jaw. “You’re impossible to ignore.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you flirting with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pressed closer. “What do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You are, Mr. Kingston.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A low chuckle rumbled in his chest. “Damn, baby, don’t call me that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aren’t you basketball’s phenom King Phillip?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t believe everything you read.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I only know what I’ve read,” Seneca countered, smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think it’s time to set the record straight. After this is over, why don’t we go somewhere and talk?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tried to ignore the feeling of uneasiness shaking her. How many times had she heard the same suggestion from countless men? To them going somewhere to talk meant trying to get her into bed—something she refused to do no matter how much they pleaded or begged. If she was going to sleep with a man, then it would be at her discretion, not his.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll give it some thought, Phillip.” His name came out in a sultry drawl.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now, that’s better. But don’t think too long, gorgeous, because I intend to blow this party before coffee and dessert.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("Seneca rested a hand atop Phillip’s much larger one, recalling Booth’s statement that Phillip was very particular about the women with whom he consorted, which led her to believe ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("he wouldn’t do anything to tarnish his good-guy image. “Let me leave first, then follow twenty minutes later,” she said sotto voce. “I’ll be waiting downstairs.”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If he was surprised by her suggestion, nothing in his expression indicated it. There was little doubt that Phillip Kingston was used to women coming on to him. But Seneca wasn’t coming on to or flirting with him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was she attracted to him? Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Did she want to know more about him? Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Would she sleep with him? No.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca had had one serious relationship, and unfortunately it ended badly. It was also unpleasant enough to make her very wary of the opposite sex.")])])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page35"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e595dc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426864223_ch02.vue
// module id = 78
// module chunks = 0